import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { useState } from "react";
import { CustomSearchBarProps } from "./types";

const CustomSearchBar = ({
  searchColumns,
  defaultFilterColumn,
  inputValue,
  hasError = false,
  errorMessage = "",
  onFilterColumnChange,
  onFilterValueChange,
}: CustomSearchBarProps) => {
  const [filterColumn, setFilterColumn] = useState<string>(defaultFilterColumn);

  return (
    <>
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <Search fontSize="small" />
          <Typography variant="subtitle1" fontWeight={600}>
            Filtro de Búsqueda
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Columna</InputLabel>
            <Select
              value={filterColumn}
              onChange={(e) => {
                setFilterColumn(e.target.value);
                onFilterColumnChange(e.target.value);
              }}
              label="Columna"
              size="small"
            >
              {searchColumns.map((column) => (
                <MenuItem key={column.id} value={column.id}>
                  {column.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            placeholder="Ingrese criterio de búsqueda..."
            value={inputValue}
            onChange={(e) => {
              onFilterValueChange(e.target.value);
            }}
            size="small"
            error={hasError}
            helperText={hasError ? errorMessage : ""}
          />
        </Box>
      </Box>
    </>
  );
};

export default CustomSearchBar;
